import { Link } from 'react-router-dom';
import { Block, ErrorNote, Eyebrow, Loading, Row, Screen, TwoCol } from '../components/primitives';
import { AffirmationBlock } from '../components/panels/today';
import { useToday } from '../lib/queries';
import { useIsDesktop } from '../lib/use-is-desktop';

/** SC-19: everything in Manifest ties back to the member's primary goal. */
export function ManifestPage() {
  const today = useToday();
  const desktop = useIsDesktop();
  if (today.isPending) return <Loading />;
  if (today.isError) return <ErrorNote error={today.error} retry={() => void today.refetch()} />;
  const goal = today.data.primaryGoal;

  const manifestation = (
    <Block
      eyebrow="Your primary manifestation"
      title={goal?.title ?? 'Set your primary goal'}
      size="lg"
      action={
        <Link
          to={goal ? `/achieve/goals/${goal.id}` : '/achieve/goals'}
          className="eyebrow underline underline-offset-4 hover:text-ink"
        >
          {goal ? 'View goal' : 'Set a goal'}
        </Link>
      }
    />
  );
  const affirmation = (
    <AffirmationBlock today={today.data} eyebrow="Affirmation for you" cta="Repeat it" />
  );

  return (
    <Screen
      wide
      eyebrow="Manifest"
      title="Manifest"
      subtitle="Clarify the vision. Strengthen the identity. Take aligned action."
    >
      {desktop ? (
        <TwoCol split="1/1" left={manifestation} right={affirmation} />
      ) : (
        <>
          {manifestation}
          {affirmation}
        </>
      )}
      <section>
        <Eyebrow className="border-b border-border px-5 pb-3 pt-7">Practices</Eyebrow>
        <Row title="Journal" meta="Today's prompt and past entries" to="/manifest/journal" />
        <Row
          title="Affirmations"
          meta="Your list and new ones for your goal"
          to="/manifest/affirmations"
        />
        <Row
          title="369 practice"
          meta="One affirmation, written 3, 6 and 9 times"
          to="/manifest/369"
        />
        <Row
          title="Vision board"
          meta="Pictures of the life you are building"
          to="/manifest/vision-board"
        />
        <Row
          title="Miracle wins"
          meta="What showed up, written down as it arrives"
          to="/manifest/wins"
        />
        <Row title="Today's alignment" meta="Seven small things for today" to="/manifest/todos" />
        <Row
          title="Toolkit"
          meta="Tapping, the water blessing, quantum jumping"
          to="/manifest/toolkit"
        />
        <Row
          title="Future self"
          meta="The person today's choices are for"
          to="/manifest/future-self"
        />
      </section>
    </Screen>
  );
}
